'use client';

import { ReactComponent as Tag } from '@assets/icons/tag.svg';
import { ReactComponent as VideoTag } from '@assets/icons/video.svg';
import Image from 'next/image';

import {
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useBoolean,
  useTheme
} from '@chakra-ui/react';

import { Loader } from 'ui';

interface ImageModalProps {
  isOpen: boolean;
  onClose: () => void;
  url: string;
  type: string;
  name: string;
}

const ImageModal = ({ isOpen, onClose, url, type, name }: ImageModalProps) => {
  const {
    colors: {
      palette: {
        shop: {
          products: {
            listStep: {
              listContainer: { container: styles }
            }
          }
        }
      }
    }
  } = useTheme();
  const [loading, setLoading] = useBoolean(true);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg='blackAlpha.600' />
      <ModalContent
        borderRadius='12px'
        margin='15px'
        maxW={{ base: '90%', md: '80%', lg: '80%' }}
      >
        <ModalCloseButton
          bg={
            url.length && type !== 'video'
              ? styles.imageBackground
              : styles.emptyImageBg
          }
          color={styles.closeButtonColor}
          _hover={{
            bg: styles.closeButtonBackground
          }}
          zIndex={10}
        />
        <ModalBody p={0} h='80vh' overflow='hidden' borderRadius='12px'>
          <Flex w='full' h='80vh' flex={1} bg={styles.imageBackground}>
            {loading && type !== 'video' && <Loader absolute />}
            {url.length && type !== 'video' ? (
              <Image
                priority
                src={url}
                fill
                quality={100}
                sizes='(max-width: 450px) 800px, 1200px'
                style={{
                  objectFit: 'contain',
                  aspectRatio: '1/1',
                  width: '100%',
                  transform: 'scale(0.85)'
                }}
                alt={`Product Slider Image ${name}`}
                onLoad={setLoading.off}
              />
            ) : (
              <Flex
                alignItems='center'
                justifyContent='center'
                my='auto'
                position='relative'
                h='full'
                w='full'
                bg={styles.emptyImageBg}
                overflow='hidden'
                sx={{
                  '& > svg': {
                    width: { base: '100px', sm: '120px' },
                    height: { base: '100px', sm: '120px' }
                  }
                }}
              >
                {type === 'video' ? (
                  <VideoTag fill={styles.defaultIconColor} />
                ) : (
                  <Tag fill={styles.defaultIconColor} />
                )}
              </Flex>
            )}
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ImageModal;
